import Vue from 'vue';
import Router from 'vue-router';
import { mobileLogin } from '@/assets/login';
import store from './../store';
import Vconsole from 'vconsole';
import { enjory } from 'assets/enjory';

process.env.VUE_APP_MODE === 'test' ? new Vconsole() : '';
Vue.use(Router);
const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { title: '河小象购课' },
      component: () => import(/* webpackChunkName: "home" */ './../views/Home.vue')
    },
    {
      path: '/createOrder',
      name: 'createOrder',
      meta: { title: '河小象购课' },
      component: () => import(/* webpackChunkName: "home" */ './../views/CreateOrder.vue')
    },
    {
      path: '/order',
      name: 'order',
      meta: { title: '我的订单' },
      component: () => import(/* webpackChunkName: "home" */ './../views/Order.vue')
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      meta: { title: '我的订单' },
      component: () => import(/* webpackChunkName: "home" */ './../views/OrderDetail.vue')
    },
    {
      path: '/paySuc',
      name: 'paySuc',
      meta: { title: '支付结果' },
      component: () => import(/* webpackChunkName: "home" */ './../views/PaySuc.vue')
    },
    {
      path: '/goOther',
      name: 'goOther',
      meta: { title: '跳转...' },
      component: () => import(/* webpackChunkName: "home" */ './../views/GoOther.vue')
    },
    {
      path: '/vcoupon',
      name: 'vCoupon',
      meta: { title: '领取优惠劵' },
      component: () => import(/* webpackChunkName: "home" */ './../views/VCoupon.vue')
    },
  ]
});

router.beforeEach((to, from, next) => {
  const { key } = store.state;
  // 连接上的referId
  // var i = document.createElement('iframe');
  // i.src = 'https://www.baidu.com/favicon.ico';
  // i.style.display = 'none';
  // i.onload = function () {
  //   setTimeout(function () {
  //     i.remove();
  //   }, 9);
  // };
  document.title = to.meta.title;
  // document.body.appendChild(i);
  if (key) {
    next();
  } else {
    mobileLogin().then(() => next());
  }
});
router.afterEach((to, from) => {
  try {
    if (['home', 'goOther', 'vCoupon'].includes(to.name)) {
      enjory('share');
    } else {
      enjory();
    }
  } catch (err) {
    console.log(err);
  }
});
export default router;
